const IGeocodeService = require('../../IGeocodeService');
/**
 * @classdesc egis地理编码服务
 * @alias G.service.GeocodeEgisServiceImpl
 * @augments G.service.IGeocodeService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.url {String} 服务地址
 * @param opts.authUrl {String} 认证服务地址
 * @param opts.clientId {String} 认证服务地址
 * @param opts.clientSecret {String} 认证服务地址
 */
class GeocodeEgisServiceImpl extends IGeocodeService {
    constructor(opts) {
        super(opts);
        this.options = {};
        for (let k in opts) {
            this.options[k] = opts[k];
        }
    }
    /**
     * @inheritdoc
     */
    getAddressByKeyword(opts) {
        
    }
    /**
     * @inheritdoc
     */
    getAddressByLocation(opts) {
        const radius = opts.radius || 1000;
        const self = this;
        return new Promise((resolve, reject) => {
            try {
                const urlAuth = self.options.authUrl + '?client_id='+self.options.clientId +'&client_secret='+ self.options.clientSecret;
                self.options.httpRequest.get(urlAuth, 'json', null, 'application/x-www-form-urlencoded', {}).then(data =>{
                    if (data.access_token) {
                        const token = data.access_token;
                        let location = opts.location;
                        const urlService = `${self.options.url}/wrgs/regeocode?radius=${radius}&location=`+location.join(',')+`&ext_poi=true&ext_road=true&format=json&client_id=${self.options.clientId}&access_token=${token}`;
                        self.options.httpRequest.get(urlService, 'json', null, 'application/x-www-form-urlencoded', {}).then((res) => {
                            resolve(res);
                        }).catch(err => {
                            reject(err);
                        })
                    }
                }).catch(err => {
                    reject(err);
                });         
            } catch (error) {
                reject(error);
            }
        })
    }
}
module.exports = GeocodeEgisServiceImpl;